/** Straight joinable run. End anchors share height; full-width boards meet without a gap. */
import { checkEnvelope, checkScope, el, partGroup } from '../../svg';
import type { PieceArt, PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, grainRng, line, rivet } from './machinerySvg';
export interface FlumeTroughParams { readonly wear: number }
export type FlumeTroughRecipe = PieceRecipe<'mill.flume_trough.v1', FlumeTroughParams>;
export const FLUME_TROUGH_FRAME = { w: 200, h: 40 } as const;
export const MILL_FLUME_TROUGH: FlumeTroughRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.flume_trough.default.v1', generatorId: 'mill.flume_trough.v1',
  seed: 20071004, paletteId: 'millrace_amber', params: { wear: 0.3 },
};
export function buildFlumeTrough(recipe: FlumeTroughRecipe, p: ResolvedPalette, scope: string): PieceArt {
  checkEnvelope(recipe, MILL_FLUME_TROUGH.generatorId); checkScope(scope);
  const wear = amount(recipe.params.wear, 'wear'), random = grainRng(recipe), parts: string[] = [];
  let channel = el('path', { d: 'M0 4H200V19H0Z', fill: p.woodShadow })
    + el('path', { d: 'M0 7H200V14H0Z', fill: p.waterFar })
    + el('path', { d: 'M0 10H200V12H0Z', fill: p.waterLight, opacity: 0.55 });
  let boards = el('path', { d: 'M0 16H200V40H0Z', fill: p.woodBase })
    + el('path', { d: 'M0 16H200V19H0ZM0 36H200V40H0Z', fill: p.woodShadow })
    + el('path', { d: 'M0 20H200V22H0Z', fill: p.woodLight });
  for (let i = 0; i < 5; i++) {
    const x = 8 + i * 38;
    boards += line(x, 27 + random(`grain.${i}`) * 5, x + 23, 28 + random(`end.${i}`) * 4, p.woodShadow, 0.6 + wear);
  }
  for (const x of [18, 97, 176]) boards += el('rect', { x, y: 15, width: 7, height: 25, fill: p.paperShadow })
    + line(x + 1, 17, x + 1, 37, p.paperBase, 1) + rivet(x + 3.5, 27, p, 1.7);
  channel += el('path', { d: 'M0 4H200V6H0Z', fill: p.woodLight });
  const body = partGroup(parts, 'flume-channel', channel) + partGroup(parts, 'flume-boards', boards);
  return { frame: FLUME_TROUGH_FRAME, body, anchors: { support: { x: 100, y: 40 }, join_left: { x: 0, y: 20 }, join_right: { x: 200, y: 20 } }, parts, openings: [] };
}
